module.exports = __webpack_public_path__ + "img/landing.aa01525c.png";